export default {
  name: 'Notification',
  computed: {
    user() {
      return this.$store.state.user;
    },
    notification() {
      return this.$store.state.notifications.notification;
    },
  },
  methods: {
    async loadNotifications() {
      if (!this.user) return;
      try {
        await this.$store.dispatch('notifications/GetNotifications', this.user.profile_id);
      } catch (error) {
        this.$store.dispatch('HandleError', error);
      }
    },
    async submitLater() {
      this.$store.commit('SetDialog', { dialog: 'notifications', value: false });
      this.$store.commit('notifications/SetLastShowTime', {
        id: this.notification.id,
        time: Math.floor(Date.now() / 1000),
      });
      await this.loadNotifications();
      this.$store.commit('SetDialog', { dialog: 'notifications', value: true });
    },
    async submit() {
      if (!this.user) return;
      // The answer action reports its own errors; refresh only after confirmation.
      const submitted = await this.$store.dispatch('notifications/successNotification', {
        profile_id: this.user.profile_id,
        notification_id: this.notification.id,
      }).catch(() => null);
      if (submitted) await this.loadNotifications();
    },
  },
};
